/**
 * Class for all Systems to derive from
 */
export class System {
}
